import { post } from '@axios';
import { updateField } from 'actions/common';
import { requests } from 'shared/requests';
import { USER_INITIATE } from 'actions/user';
import { showLoader, hideLoader } from 'actions/loader';
import { getAllProducts } from 'actions/products';
import { SHOW_ERROR_MODAL } from 'actions/errorModal';

const AUTH_SUCCESS = 'AUTH_SUCCESS';
const AUTH_ERROR = 'AUTH_ERROR';
const AUTH_LOGOUT = 'AUTH_LOGOUT';

const signUp = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const request = await post({ url: requests.signUp, data });
      dispatch(hideLoader());

      dispatch(updateField(USER_INITIATE));
      return request;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      dispatch(updateField(AUTH_ERROR, { error: error.message }));
      return { error: true, message: error.message };
    }
  };
};

const login = (data) => {
  return async (dispatch) => {
    dispatch(showLoader());
    try {
      const request = await post({ url: requests.login, data });
      dispatch(hideLoader());

      if (request?.error) {
        return { error: true, message: request.error };
      }

      if (request?.Status === 'In-Active') {
        return {
          error: true,
          message: 'Your account is deactivated. Please contact to Shirtly.',
        };
      } else if (request?.Status === 'InProcess') {
        return {
          error: true,
          inProcess: true,
        };
      } else if (request?.Status === 'Declined') {
        return {
          error: true,
          declined: true,
        };
      }

      await dispatch(
        getAllProducts({
          authenticated: true,
          profile: {
            group: request?.Group,
          },
        })
      );

      dispatch(
        updateField(AUTH_SUCCESS, {
          data: {
            emailid: request?.User?.Email,
            User_Id: request?.User_Id,
            FullName: request?.User?.FullName,
            ID: request?.ID,
            group: request?.Group,
            printLabel: request?.PrintLabel,
            paymentSkip: request?.PaymentSkip,
            token: request?.token,
          },
        })
      );

      return request;
    } catch (error) {
      dispatch(hideLoader());
      dispatch({ type: SHOW_ERROR_MODAL });
      dispatch(updateField(AUTH_ERROR, { error: error.message }));
      return { error: true, message: error.message };
    }
  };
};

export { AUTH_SUCCESS, AUTH_ERROR, AUTH_LOGOUT, signUp, login };
